import { CircularBar } from './CircularBar';
import { LabelBar } from './LabelBar';
import { LinearBar } from './LinearBar';

export const ProgressBar = {
  CircularBar,
  LinearBar,
  LabelBar,
};
